import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { AccountService } from "src/app/core/services/account.service";
import { Account } from "../models/account";

@Injectable({ providedIn: 'root' })
export class AccountResolver implements Resolve<Account> {
  constructor(private accountService: AccountService) {}

  resolve(): Observable<Account> {
    return this.accountService.fetchAccount();
  }
}